import { FC } from "react";
import styled from "styled-components";

import { Modal } from "@/components/Modal";
import { CloseButton, StyledDialog } from "@/components/AlertDialogs/Dialog";
import Text from "@/components/Text";
import { AudiencableChannel } from "@/types/resources";
import TestingAudienceChannelCard from "@/components/TestingAudienceChannelCard";

const Dialog = styled(StyledDialog)`
  padding: 56px 12px 24px;
  width: 704px;
  max-height: 504px;
  display: flex;
  flex-direction: column;
`;

const ChannelsList = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-top: 24px;
  padding: 0 12px;
  text-align: left;

  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.lightGray};
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 8px;
`;

interface Props {
  onClose: () => void;
  channels: AudiencableChannel[];
}

const TargetAudienceModal: FC<Props> = ({ onClose, channels }) => {
  return (
    <Modal>
      <Dialog
        initial={{ scale: 0.3 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.3 }}
      >
        <CloseButton onClick={onClose}>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 13L1 1"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </CloseButton>
        <Text $type="heading2">Audience Channels</Text>
        <ChannelsList>
          <Grid>
            {channels.map((channel) => (
              <TestingAudienceChannelCard
                channel={channel}
                key={channel.external_id}
              />
            ))}
          </Grid>
        </ChannelsList>
      </Dialog>
    </Modal>
  );
};

export default TargetAudienceModal;
